var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"clientes_services"},[_c('Services',{attrs:{"cliente":_vm.cliente}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }